import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { isString } from '@fi-shared/utils/is-string';

@Pipe({
    name: 'protocolIndependent',
    standalone: false,
})
@Injectable()
export class ProtocolIndependentPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (!value || !isString(value)) return value;

        return value.replace('http://', '//').replace('https://', '//');
    }
}
